var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axiosInstance from '../../store/AxiosSingleton';
import { ForumMessage } from 'forum/classes/ForumMessage.class';
import { Sujet } from 'forum/classes/Sujet.class';
import { Thematique } from 'forum/classes/Thematique.class';
import { ThematiqueData } from 'forum/classes/ThematiqueData.class';
export class ForumService {
    /**
     * Charge les thématiques et les sujets associés
     */
    static loadThematique() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: ForumService.rubModule,
                    action: 'LOAD_THEMATIQUE',
                },
            });
            return content.map((rep) => ({
                thematique: new Thematique(rep.thematique),
                sujet: new Sujet(rep.sujet),
            }));
        });
    }
    /**
     * Charge les sujets d'une thématique
     * @param filter Filtres à appliquer
     * @return Sujets récupérés
     */
    static loadSujets(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: ForumService.rubModule, action: 'LOAD_SUJETS' }, filter),
            });
            return content.map((maReponse) => ({
                sujet: new Sujet(maReponse.sujet),
                dernierMessage: new ForumMessage(maReponse.dernierMessage),
            }));
        });
    }
    /**
     * Charge les messages d'un sujet
     * @param filter Filtres à appliquer
     * @return Messages récupérés
     */
    static loadMessagesSujet(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: ForumService.rubModule, action: 'LOAD_MESSAGES_SUJET' }, filter),
            });
            return {
                messages: content.messages.map((message) => new ForumMessage(message)),
                sujet: new Sujet(content.sujet),
                isFollow: content.isFollow,
            };
        });
    }
    /**
     * Charge un sujet à partir de son identifiant
     * @param idSujet Identifiant du sujet
     * @return Le sujet trouvé
     */
    static getSujet(idSujet) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: ForumService.rubModule,
                    action: 'GET_SUJET',
                    idSujet,
                },
            });
            return new Sujet(content);
        });
    }
    /**
     * Récupère les données d'une thématique
     * @param filter Filtres à appliquer
     * @return Données de la thématique
     */
    static loadThematiqueData(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: ForumService.rubModule, action: 'LOAD_THEMATIQUE_DATA' }, filter),
            });
            return new ThematiqueData(content);
        });
    }
    /**
     * Ajout d'un sujet à une thématique
     * @param sujet Sujet à insérer
     * @return Si action réussie renvoie l'identifiant du sujet inséré, sinon null
     */
    static addSujet(sujet) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                sujet: sujet.toRaw(),
            }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'SAVE_SUJET',
                },
            });
            return content;
        });
    }
    /**
     * Déplacement d'un sujet dans une autre thématique
     * @param idSujet Identifiant du sujet à déplacer
     * @param idThematique Identifiant de la thématique de destination
     * @return Succès de l'opération
     */
    static moveSubject(idSujet, idThematique) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idSujet, idThematique }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'MOVE_SUBJECT',
                },
            });
            return content;
        });
    }
    /**
     * Suppression d'un sujet dans une thématique
     * @param idSujet Sujet à supprimer
     * @param commentaire Commentaire sur la suppression (optionnel)
     * @param raison Identifiant de raison (optionnel)
     * @return Succès de l'opération
     */
    static deleteSubject(idSujet, commentaire, raison) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: ForumService.rubModule,
                    action: 'DELETE_SUBJECT',
                    idSujet,
                    raisonSuppression: raison,
                    commentaireSuppression: commentaire,
                },
            });
            return content;
        });
    }
    /**
     * Clôture d'un sujet dans une thématique
     * @param idSujet Sujet à clore/déverrouiller
     * @return Succès de l'opération
     */
    static closeSubject(idSujet) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idSujet }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'CLOSE_SUBJECT',
                },
            });
            return content;
        });
    }
    /**
     * Epingle un sujet dans une thématique
     * @param idSujet Sujet à épingler/désépingler
     * @return Succès de l'opération
     */
    static pinSubject(idSujet) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idSujet }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'PIN_SUBJECT',
                },
            });
            return content;
        });
    }
    /**
     * Ajout d'un like sur un message
     * @param idMessage Identifiant du message liké
     * @return Succès de l'opération
     */
    static addLike(idMessage) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idMessage }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'SAVE_LIKE',
                },
            });
            return content;
        });
    }
    /**
     * Suppression d'un like sur un message
     * @param idMessage Identifiant du message dont on souhaite enlever le like
     * @return Succès de l'opération
     */
    static deleteLike(idMessage) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: ForumService.rubModule,
                    action: 'DELETE_LIKE',
                    idMessage,
                },
            });
            return content;
        });
    }
    /**
     * Ajoute un suivi sur un sujet
     * @param urlSujet Lien du sujet à suivre
     * @return Succès de l'opération
     */
    static addFollow(urlSujet) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { urlSujet }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'SAVE_FOLLOW',
                },
            });
            return content;
        });
    }
    /**
     * Suppression d'un suivi sur un sujet
     * @param urlSujet Lien du sujet à ne plus suivre
     * @return Succès de l'opération
     */
    static deleteFollow(urlSujet) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: ForumService.rubModule,
                    action: 'DELETE_FOLLOW',
                    urlSujet,
                },
            });
            return content;
        });
    }
    /**
     * Ajoute un nouveau message à un sujet
     * @param message Message à ajouter
     * @return True si insertion réussie, false sinon
     */
    static addMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!message) {
                return null;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                message: message.toRaw(),
            }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'SAVE_MESSAGE',
                },
            });
            return content;
        });
    }
    /**
     * Supprime un message d'un sujet
     * @param message Message à supprimer
     * @return True si la suppression a réussie, false sinon
     */
    static deleteMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: ForumService.rubModule,
                    action: 'DELETE_MESSAGE',
                    idMessage: message.idForumMessage,
                },
            });
            return content;
        });
    }
    /**
     * Modifie un message
     * @param message Message à modifier
     * @return True si la modification a réussie, false sinon
     */
    static updateMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { message: message.toRaw() }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'UPDATE_MESSAGE',
                },
            });
            return content;
        });
    }
    /**
     * Passe un sujet suivi en lu
     * @param idSujet L'identifiant du sujet vu
     * @return True si l'opération a réussie, false sinon
     */
    static subjectSeen(idSujet) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { success }, } = yield axiosInstance.post('/index.php', { idSujet }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'SUBJECT_SEEN',
                },
            });
            return success;
        });
    }
    /**
     * Restaure un message du forum
     * @param message Message que l'on souhaite restaurer
     * @return Succès de l'opération
     */
    static restoreMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idMessage: message.idForumMessage }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'RESTORE_MESSAGE',
                },
            });
            return content;
        });
    }
}
ForumService.rubModule = 'forum';
//# sourceMappingURL=data:application/json;base64,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